import { Controller } from "@hotwired/stimulus";

export default class DestinationToursListController extends Controller {
    static targets = ['tour'];
    static values = {
        tourCount: Number,
        tourCountPlaceholderElementId: String,
    };

    readonly tourCountValue!: number;
    readonly tourCountPlaceholderElementIdValue!: string;
    readonly tourTargets!: HTMLElement[];

    connect() {
        const tourCountElement = document.getElementById(this.tourCountPlaceholderElementIdValue);
        if (tourCountElement) {
            tourCountElement.innerText = `(${this.tourCountValue})`;
        }

        this.toggleTourTargetsVisibility(false);
    }

    toggleHiddenToursVisibility(event: Event) {
        if (!event.currentTarget) return;
        const checkbox = event.currentTarget as HTMLInputElement;
        const showHiddenTours = checkbox.checked;
        this.toggleTourTargetsVisibility(showHiddenTours);
    }

    private toggleTourTargetsVisibility(showHiddenTours: boolean) {
        this.tourTargets.forEach(tourEl => {
            const isHidden = tourEl.dataset['isHidden'] !== undefined;
            tourEl.hidden = isHidden && !showHiddenTours;
        });
    }
}
